/**
 * Client-side search: row matches if any string from getStrings(row) contains the query (case-insensitive).
 */
export function filterBySearch(rows, query, getStrings) {
  const q = (query || '').trim().toLowerCase();
  const list = Array.isArray(rows) ? rows : [];
  if (!q) return list;

  return list.filter((row) => {
    const raw = getStrings(row);
    const parts = (Array.isArray(raw) ? raw : [raw])
      .flat(Infinity)
      .filter((x) => x != null && x !== '')
      .map((x) => String(x).toLowerCase());
    return parts.some((s) => s.includes(q));
  });
}
